import FieldsCollection from "../../fields3/collection/base/fields-collection";
import {EntityType} from "../../gd/const/item";
import {FieldType} from "../../fields3/field-type";
import {EmailContentType} from "./const";
import FieldConfig from "../../fields3/proto/field-config";
import FieldString from "../../fields3/generic/string/string";
import FieldDropdown from "../../fields3/generic/dropdown/dropdown";
import FieldText from "../../fields3/generic/text/text";


const baseConfig : FieldConfig[] = [
    {
        fieldId : 'name',
        type    : FieldType.STRING,
        label   : 'Template name'
    },
    {
        fieldId : 'subject',
        type    : FieldType.STRING,
        label   : 'Subject'
    },
    {
        fieldId : 'replyTo',
        type    : FieldType.STRING,
        label   : 'Replay To'
    },
    {
        fieldId : 'cc',
        type    : FieldType.STRING,
        label   : 'CC'
    },
    {
        fieldId : 'contentType',
        type    : FieldType.DROPDOWN,
        label   : 'Content Type',
        options : [
            {
                label   : 'Text',
                value   : EmailContentType.TEXT
            },
            {
                label   : 'Html',
                value   : EmailContentType.HTML
            }
        ],
        noValueOption   : false,
        showMenuMore    : false
    },
    {
        fieldId : 'contentHTML',
        type    : FieldType.TEXT,
        label   : 'HTML Code'
    },
    {
        fieldId : 'contentTXT',
        type    : FieldType.TEXT,
        label   : 'Content'
    }
]

export default class EmailTemplateFields extends FieldsCollection {


    // Quick access

    get name()                      : FieldString { return this.get('name') as FieldString }
    get subject()                   : FieldString { return this.get('subject') as FieldString }
    get replyTo()                   : FieldString { return this.get('replyTo') as FieldString }
    get cc()                        : FieldString { return this.get('cc') as FieldString }
    get contentType()               : FieldDropdown { return this.get('contentType') as FieldDropdown }
    get contentHTML()               : FieldText { return this.get('contentHTML') as FieldText }
    get contentTXT()                : FieldText { return this.get('contentTXT') as FieldText }

    constructor() {

        const fieldsConfig = baseConfig;
        // we can modify base config with params in constructor if needed

        super(fieldsConfig, EntityType.EMAIL_TEMPLATE);

    }



}
